export const ADD_ERROR_LOG = "ADD_ERROR_LOG";

// 用户
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_KEY_VAL = "SET_USER_KEY_VAL";
export const SET_USER_LOT_USER_ACCOUNT = "SET_USER_LOT_USER_ACCOUNT";

// 余额宝
export const SET_USER_YEB_INFO = "SET_USER_YEB_INFO";

// 借呗
export const SET_USER_LEND_INFO = "SET_USER_LEND_INFO";

//代理中心
export const ADD_AGENT_BETTINGINFO_LIST = "ADD_AGENT_BETTINGINFO_LIST";
export const ADD_AGENT_BALANCEDETAIL_LIST = "ADD_AGENT_BALANCEDETAIL_LIST";
export const ADD_AGENT_SUBUSERREBATE_LIST = "ADD_AGENT_SUBUSERREBATE_LIST";
export const ADD_AGENT_SUBUSER_ONE_REPORT = "ADD_AGENT_SUBUSER_ONE_REPORT";
export const ADD_AGENT_TEAM_REPORT = "ADD_AGENT_TEAM_REPORT";
export const ADD_AGENT_SUBUSER_LIST = "ADD_AGENT_SUBUSER_LIST";

// 走势
export const ADD_TREND_DISPS_LIST = "ADD_TREND_DISPS_LIST";
export const ADD_TREND_RECORDS_LIST = "ADD_TREND_RECORDS_LIST";
export const ADD_TREND_LOTTERY_TYPES = "ADD_TREND_LOTTERY_TYPES";
export const SET_TREND_CURRENT_LOTTERY = "SET_TREND_CURRENT_LOTTERY";

// 系统字典
export const SET_SYSDICT_SYSTEMCONFIG = "SET_SYSDICT_SYSTEMCONFIG";

// 游戏大厅
export const SET_LOTTERY_AllLOTTEY_SWITCH = "SET_LOTTERY_AllLOTTEY_SWITCH";
export const SET_SYSDICT_ITEMLIST = "SET_SYSDICT_ITEMLIST";

//首页
export const ADD_HOME_INDEX = "ADD_HOME_INDEX";

//用戶
export const ADD_USER_EXPANDPLATFORM_TYPE = "ADD_USER_EXPANDPLATFORM_TYPE";
export const SET_USER_UNCLAIMED_REDPACKET = "SET_USER_UNCLAIMED_REDPACKET";

//APP
export const SET_APP_DOWNLOADurl = "SET_APP_DOWNLOADurl";
export const SET_APP_CONFIG = "SET_APP_CONFIG";
export const ADD_APP_RECENTLY_PLAYED = "ADD_APP_RECENTLY_PLAYED";
//CMS
export const SET_CMS_SERVICER = "SET_CMS_SERVICER";
export const SET_CMS_QRCODES = "SET_CMS_QRCODES";
// 聊天室
export const SET_CHAT_PUSH_MEMBER_MSG = "SET_CHAT_PUSH_MEMBER_MSG"; // 后台推送用户消息
export const SET_CHATROOM_INSTANCE_SPEAK_STATUS =
  "SET_CHATROOM_INSTANCE_SPEAK_STATUS";
export const SET_CHAT_LOADING_MORE_MESSAGE = "SET_CHAT_LOADING_MORE_MESSAGE"; // 获取历史消息
export const SET_CHATROOM_LAYOUT_GAME = "SET_CHATROOM_LAYOUT_GAME";
export const SET_CHAT_CURRENT_CONTACT = "  SET_CHAT_CURRENT_CONTACT";
export const UPDATE_CHAT_CONTACT = "UPDATE_CHAT_CONTACT";
// 后台修改用户禁言状态存储状态
export const CHANGE_CURR_CHAT_USER_INFO = "CHANGE_CURR_CHAT_USER_INFO";
// 加入聊天室状态
export const SET_CHATROOM_JOIN_STATE = "SET_CHATROOM_JOIN_STATE";
// 将要切换到的房间信息 SET_WILL_SWITCH_CHAT_ROOM_INFO,SET_CURR_CHAT_ROOM_INFO
export const SET_WILL_SWITCH_CHAT_ROOM_INFO = "SET_WILL_SWITCH_CHAT_ROOM_INFO";
//当前房间用户信息
export const SET_CURR_CHAT_ROOM_INFO = "SET_CURR_CHAT_ROOM_INFO";
export const SET_CURR_CHAT_ROOM_USER_INFO = "SET_CURR_CHAT_ROOM_USER_INFO";
export const RQ_SET_CHAT_ROOM_INFO = "RQ_SET_CHAT_ROOM_INFO";
export const SET_CHAT_USER = "SET_CHAT_USER";
// export const SET_CHATROOM_INFO = "SET_CHATROOM_INFO";
export const SET_CHATUSER_KEY_VAL = "SET_CHATUSER_KEY_VAL";
export const ADD_CHATROOM_MSG = "ADD_CHATROOM_MSG";
// export const SET_CHATROOM_PERERSON_INFO = "SET_CHATROOM_PERERSON_INFO";
export const SET_CHATROOM_PRIZE_INFO = "SET_CHATROOM_PRIZE_INFO";
export const SET_CHATROOM_NOTICE_MODIFY = "SET_CHATROOM_NOTICE_MODIFY";
export const SET_CHATROOM_All_SPEACKSTATUS = "SET_CHATROOM_All_SPEACKSTATUS";
export const SET_CHATROOM_VARIOUT_MSG = "SET_CHATROOM_VARIOUT_MSG";
export const SET_CHATROOM_HEADLINE = "SET_CHATROOM_HEADLINE";
export const SET_CHATROOM_PIN_TIMER = "SET_CHATROOM_PIN_TIMER";
export const SET_CHATROOM_SCROLL_TO_PIN = "SET_CHATROOM_SCROLL_TO_PIN";
export const SET_CHATROOM_LIST = "SET_CHATROOM_LIST";
// export const SET_CHAT_ISHIDE_PWDVIEW = "SET_CHAT_ISHIDE_PWDVIEW";
export const SET_CHATROOM_REDPACKET_TRANSLATE_X =
  "SET_CHATROOM_REDPACKET_TRANSLATE_X";
export const SET_CHATROOM_REDPACKET_INFO = "SET_CHATROOM_REDPACKET_INFO";
// export const
export const SET_CHATROOM_VISIBLE_OPEN_REDPACKET =
  "SET_CHATROOM_VISIBLE_OPEN_REDPACKET";
export const SET_CHATROOM_OPEN_REDPACKET_INFO =
  "SET_CHATROOM_OPEN_REDPACKET_INFO";
export const SET_CHATROOM_VISIBLE_REDPACKET_DETAIL =
  "SET_CHATROOM_VISIBLE_REDPACKET_DETAIL";
export const SET_CHATROOM_REDPACKET_MONEYINFO =
  "SET_CHATROOM_REDPACKET_MONEYINFO";
export const SET_CHATROOM_REDPACKET_LIST = "SET_CHATROOM_REDPACKET_LIST";
export const SET_CHATROOM_REDPACKET_DSC = "SET_CHATROOM_REDPACKET_DSC";
export const SET_CHATROOM_ANNOUNCE_INFO = "SET_CHATROOM_ANNOUNCE_INFO";
export const SET_CHATROOM_VISIBLE_FOLLOW_ORDER =
  "SET_CHATROOM_VISIBLE_FOLLOW_ORDER";
export const SET_CHATROOM_FOLLOW_ORDER_INFO = "SET_CHATROOM_FOLLOW_ORDER_INFO";
export const SET_CHATROOM_FOLLOW_ORDER_TIMETXT =
  "SET_CHATROOM_FOLLOW_ORDER_TIMETXT";
export const SET_CHATROOM_FOLLOW_ORDER_BETTING_MONEY =
  "SET_CHATROOM_FOLLOW_ORDER_BETTING_MONEY";
export const SET_CHATROOM_FOLLOW_ORDER_BETTING_CLOSE =
  "SET_CHATROOM_FOLLOW_ORDER_BETTING_CLOSE";
export const SET_CHATROOM_FOLLOW_REQORDER_INFO =
  "SET_CHATROOM_FOLLOW_REQORDER_INFO";
export const SET_CHATROOM_FOLLOW_ORDER_TIMER =
  "SET_CHATROOM_FOLLOW_ORDER_TIMER";
export const SET_CURRENT_CHAT_PRIVATE_RECEIVE_USER =
  "SET_CURRENT_CHAT_PRIVATE_RECEIVE_USER";
export const SET_CURRENT_CHAT_PRIVATE_VIPINFO =
  "SET_CURRENT_CHAT_PRIVATE_VIPINFO";

export const CLEAR_CHATROOM_MESSAGE_LIST = "CLEAR_CHATROOM_MESSAGE_LIST";
export const SET_CHATROOM_MESSAGE_LIST = "SET_CHATROOM_MESSAGE_LIST";
export const SET_LOTTERY_RECORD_LIST = "SET_LOTTERY_RECORD_LIST";
// export const set_sent-private-room-targetId
export const SET_PRIVATE_ROOM_TARGET_ID = "SET_PRIVATE_ROOM_TARGET_ID";
export const IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE =
  "IS_SHOW_SINGLE_PRIVATE_MSG_NOTICE";
export const IS_OPEN_PRIVATE_MSG_NOTICE_SWITCH =
  "IS_OPEN_PRIVATE_MSG_NOTICE_SWITCH";
export const IS_OPEN_CHAT_ROOM_PRIZE_NOTICE = "IS_OPEN_CHAT_ROOM_PRIZE_NOTICE";

// 红包大战
export const SET_WILL_SWITCH_HB_BATTLE_ROOM_INFO =
  "SET_WILL_SWITCH_HB_BATTLE_ROOM_INFO";
export const SET_CURR_HB_ROOM_INFO = "SET_CURR_HB_ROOM_INFO";
export const ADD_HB_BATTLE_ROOM_MSG = "ADD_HB_BATTLE_ROOM_MSG";
// 抢庄
export const SET_GRAB_PERIOD = "SET_GRAB_PERIOD";
export const SET_GRAB_ROOM_ID = "SET_GRAB_ROOM_ID";
export const ADD_GRAB_ROOM_MESSAGE = "ADD_GRAB_ROOM_MESSAGE";
export const SET_GRAB_ROOM_SPEECH_MODE = "SET_GRAB_ROOM_SPEECH_MODE";

// 借呗余额宝页面返回问题
export const SET_YEBFROM_PAGE = "SET_YEBFROM_PAGE";
export const SET_JBFROM_PAGE = "SET_JBFROM_PAGE";

export const ADD_GRAB_AITE_PEOPLE = "ADD_GRAB_AITE_PEOPLE";
export const DELETE_GRAB_AITE_PEOPLE = "DELETE_GRAB_AITE_PEOPLE";
export const CLEAR_GRAB_AITE_PEOPLE = "CLEAR_GRAB_AITE_PEOPLE";
export const SET_GRAB_AITE_MESSAGE = "SET_GRAB_AITE_MESSAGE";
export const SET_GRAB_ROOM_INFO = "SET_GRAB_ROOM_INFO";
export const SET_GRAB_ROOM_MESSAGE = "SET_GRAB_ROOM_MESSAGE";
export const SET_GRAB_LOTTERY_DOWNTIME = "SET_GRAB_LOTTERY_DOWNTIME";
export const SET_GRAB_MSG_BAR_OPEN = "SET_GRAB_MSG_BAR_OPEN";
export const SET_GRAB_JOIN_ROOM_STATE = "SET_GRAB_JOIN_ROOM_STATE";
export const SET_GRAB_PEOPLE_INFO = "SET_GRAB_PEOPLE_INFO";
export const DELETE_GRAB_MESSAGE_LIST = "DELETE_GRAB_MESSAGE_LIST";
export const SET_GRAB_IS_DISTER_VILLAGE = "SET_GRAB_IS_DISTER_VILLAGE";
export const SET_GRAB_RECEIVE_ROOM_MSG = "SET_GRAB_RECEIVE_ROOM_MSG";
export const UPDADE_GRAB_ROOM_MESSAGE = "UPDADE_GRAB_ROOM_MESSAGE";
export const CLEAR_GRAP_ROOM_INFO_USER = "CLEAR_GRAP_ROOM_INFO_USER";
export const SET_GRAP_SELF_JOIN_TIME = "SET_GRAP_SELF_JOIN_TIME";
export const SET_GRAB_URL_INFO = "SET_GRAB_URL_INFO";
export const SET_GRAP_OLD_BRANKER = "SET_GRAP_OLD_BRANKER";

export const SET_LOTTERY_INFO = "SET_LOTTERY_INFO";
export const SET_THEME_COLOR = "SET_THEME_COLOR";
export const SET_PAGE_TEMPLATE = "SET_PAGE_TEMPLATE";
//设置提交私聊消息列表state字段
export const SET_CHAT_ROOM_PRIVATE_MSG_LIST = "SET_CHAT_ROOM_PRIVATE_MSG_LIST";
//私聊单个消息
export const ADD_SINGLE_PRIVATE_MSG = "ADD_SINGLE_PRIVATE_MSG";
//聊天室自己的消息
export const ADD_CHAT_ROOM_SELF_MSG = "ADD_CHAT_ROOM_SELF_MSG";
//聊天室真实人员列表
export const QUERY_CHAT_ROOM_PERSONS = "QUERY_CHAT_ROOM_PERSONS";
//所有未读消息总数
// export const SET_UNREAD_PRIVATE_MSG_COUNT = 'SET_UNREAD_PRIVATE_MSG_COUNT';
//聊天室客服消息
// export const ADD_CUSTOMER_SERVICE_MSG = 'ADD_CUSTOMER_SERVICE_MSG';
//聊天室客服单个消息

//是否关闭app下载
export const APP_IS_DOWNLOAD_OR_NOT = "APP_IS_DOWNLOAD_OR_NOT";

// rongyun.js 融云相关
export const SAVE_RONGYUN_INFO = "SAVE_RONGYUN_INFO";
export const SAVE_RONGYUN_TOKEN_INFO = "SAVE_RONGYUN_TOKEN_INFO";
export const SAVE_RONGYUN_CHATROOM_JOIN_STATUS =
  "SAVE_RONGYUN_CHATROOM_JOIN_STATUS";
export const SAVE_RONGYUN_CONNECT_STATUS = "SAVE_RONGYUN_CONNECT_STATUS";
export const ADD_RONGYUN_MESSAGE = "ADD_RONGYUN_MESSAGE";
export const SAVE_RONGYUN_CONVERSATION_LIST = "SAVE_RONGYUN_CONVERSATION_LIST";
export const SET_RY_CONNECT_SUCCESS = "SET_RY_CONNECT_SUCCESS";

export const SET_CURRENCY_EXCHANGE_INFO = "SET_CURRENCY_EXCHANGE_INFO";

// sysDict.js 系统配置相关
export const SET_SYS_EXCHANGE_INFO = "SET_SYS_EXCHANGE_INFO";
export const SAVE_SYSTEM_API_COIN = "SAVE_SYSTEM_API_COIN";

// export const SAVE_BETSHARE_TODAY_BETWIN = "SAVE_BETSHARE_TODAY_BETWIN";
//
export const SAVE_APP_LANGUAGE_CONFIG = "SAVE_APP_LANGUAGE_CONFIG";
export const SAVE_APP_LANGUAGE = "SAVE_APP_LANGUAGE";

export const SAVE_CMS_DISCOUNTS = "SAVE_CMS_DISCOUNTS";

export const SAVE_AGENT_DESC = "SAVE_AGENT_DESC";
